import apiClient from "../api";

/**
 * Service pour la gestion des documents de transaction
 * Fournit les méthodes pour récupérer et manipuler les documents associés aux transactions
 */
class TransactionDocumentService {
  
  /**
   * Récupère tous les documents associés à une transaction spécifique
   * @param {number} transactionId - ID de la transaction
   * @param {number} domainId - ID du domaine pour la sécurité
   * @returns {Promise<Array>} Liste des documents de la transaction
   */
  static async getTransactionDocuments(transactionId, domainId) {
    try {
      const response = await apiClient.get(
        `/api/transactiondocuments/${transactionId}/documents?domainId=${domainId}`
      );
      return response.data;
    } catch (error) {
      // console.error('Erreur lors de la récupération des documents de la transaction:', error);
      throw new Error(
        error.response?.data?.message || 
        'Impossible de charger les documents de la transaction'
      );
    }
  }

  /**
   * Ouvre un document de transaction dans un nouvel onglet
   * @param {string} url - URL signée du document
   * @param {string} documentName - Nom du document pour le logging
   */
  static async openTransactionDocument(url, documentName) {
    try {
      // Vérifier si c'est un PDF pour une ouverture optimisée
      if (url.toLowerCase().includes('.pdf') || documentName.toLowerCase().includes('.pdf')) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        // Pour les images et autres documents, ouvrir dans un nouvel onglet
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      // console.error('Erreur lors de l\'ouverture du document:', error);
      throw new Error('Impossible d\'ouvrir le document');
    }
  }

  /**
   * Télécharge un document de transaction
   * @param {string} url - URL signée du document
   * @param {string} fileName - Nom du fichier pour le téléchargement
   */
  static async downloadTransactionDocument(url, fileName) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName || 'document-transaction';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      // console.error('Erreur lors du téléchargement:', error);
      throw new Error('Impossible de télécharger le document');
    }
  }
}

export default TransactionDocumentService;